import React, { useEffect, useState } from "react";
import {Link} from "react-router-dom";

const HeaderBlock = ({homePage = true}) => {
    const [navbar, setNavbar] = useState(false);
    const changeBackground = () => {
        if (window.scrollY >= 10) {
            setNavbar(true);
        } else {
            setNavbar(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", changeBackground);
        return () => window.removeEventListener("scroll", changeBackground);
    }, []);

    return (
        <header
            className={`main-header header-shaddow -type-11 ${
                navbar ? "fixed-header animated slideInDown" : ""
            }`}
        >
            <div className="main-box">
                <div className="nav-outer">
                    <div className="logo-box">
                        <div className="logo">
                            {homePage ? (
                                <a href="/#">
                                    <img src="/images/Logo-GTH-white.png" alt="logo" className="logo" width={252} height={78}/>
                                </a>
                            ) : (
                                <img src="/images/Logo-GTH-white.png" alt="logo" className="logo" width={252} height={78}/>
                            )}
                        </div>
                    </div>
                    <nav className="navbar">
                        {homePage ? (
                        <ul className="nav-list">
                            <li className="nav-item dropdown">
                                <span className="nav-link">Nos services</span>
                                <ul className="dropdown-menu">
                                    <li><a href="#forum" className="dropdown-item">Forums en ligne Emploi Handicap</a></li>
                                    <li><a href="#formation" className="dropdown-item">Formation et Sensibilisation Handicap</a></li>
                                    <li><a href="#webinaires" className="dropdown-item">Webinaires de sensibilisation</a></li>
                                    <li><a href="#hotline" className="dropdown-item">Hotline Handicap</a></li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <a href="#video" className="nav-link">Le Groupe</a>
                            </li>

                            <li className="nav-item">
                                <a href="#contact" className="nav-link contact-link">Contactez-nous</a>
                            </li>
                        </ul>
                        ) : (
                            <Link to={'/'} className={'nav-link'}>Retour à l'accueil</Link>
                        )}
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default HeaderBlock;
